import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
//
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
//
import MenuTable from './MenuTable';
//
import Loader from 'src/components/Loader';
import { allFooterMenus } from 'src/Redux/actions/footerActions';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export default function FooterMenuTabs() {
  const [value, setValue] = useState(0);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // Get All menus
  const pageState = useSelector((state) => state.footerContent?.footer);
  const [pageSections, setPageSection] = useState({
    data: []
  });
  const formData = pageState;

  useEffect(() => {
    setPageSection({
      ...formData
    });
  }, [pageState?.data]);

  useEffect(() => {
    const fetchData = () => {
      try {
        setLoading(true);
        setTimeout(() => {
          dispatch(allFooterMenus());
          setLoading(false);
        }, 1000);
      } catch (error) {
        setLoading(true);
      }
    };
    fetchData();
  }, []);

  // Change Menu Values
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {loading && <Loader />}
      {!loading && (
        <Box sx={{ mt: 2 }}>
          <Box sx={{ width: '100%' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              aria-label="visible arrows tabs example"
              sx={{
                [`& .${tabsClasses.scrollButtons}`]: {
                  '&.Mui-disabled': { opacity: '0.3' }
                }
              }}
            >
              {pageState.data?.map((item, index) => {
                if (!item?.countryName == '')
                  return (
                    <Tab key={item.countryName} label={item.countryName} {...a11yProps(index)} />
                  );
              })}
            </Tabs>
          </Box>

          {pageState.data?.map((item, index) => {
            if (!item?.footer == '')
              return (
                <TabPanel key={item.countrySlug} value={value} index={index}>
                  <Box sx={{ borderRadius: 1, border: '1px solid #929eaa6b' }}>
                    <MenuTable menus={item} menuId={item.countrySlug} />
                  </Box>
                </TabPanel>
              );
          })}
        </Box>
      )}
    </>
  );
}
